import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { BrandIconDoctor } from '@redteclab/brand-icons'

import { BrandIcon } from 'base-ui'

import {
  erxBonusLandingPageTextAccent,
  erxBonusLandingPageTextBreak,
} from '../../../../components/ErxBonusLandingPageTranslationValues'

import { ErxBonusLandingPageHowBonusIsCalculatedExampleV1 } from './ErxBonusLandingPageHowBonusIsCalculatedExample'
import { ErxBonusLandingPageHowBonusIsCalculatedInfoV1 } from './ErxBonusLandingPageHowBonusIsCalculatedInfo'

export const HOW_BONUS_CALCULATED_SECTION_ID = 'how-bonus-is-calculated'

export const ErxBonusLandingPageHowBonusIsCalculatedV1: FC = () => {
  return (
    <div
      className="flex scroll-mt-4 flex-col gap-6"
      id={HOW_BONUS_CALCULATED_SECTION_ID}
    >
      <div className="px-5 text-center text-2xl font-medium tablet:px-0 tablet:text-3xl">
        <FormattedMessage
          id="deErx.bonus.howBonusIsCalculated.title"
          values={{
            accentuate: erxBonusLandingPageTextAccent,
            break: erxBonusLandingPageTextBreak,
          }}
        />
      </div>

      <div className="flex flex-col gap-6 tablet:flex-row">
        <ErxBonusLandingPageHowBonusIsCalculatedInfoV1 />
        <ErxBonusLandingPageHowBonusIsCalculatedExampleV1 />
      </div>

      <div className="flex shrink-0 grow-0 gap-4 rounded-3xl bg-light-primary-low p-6">
        <BrandIcon
          className="size-12 shrink-0 grow-0"
          color="secondary"
          icon={BrandIconDoctor}
        />
        <div className="flex flex-col gap-2">
          <span className="text-m font-medium">
            <FormattedMessage id="deErx.bonus.howBonusIsCalculated.copaymentExemption.title" />
          </span>
          <span className="flex text-dark-primary-strong">
            <FormattedMessage id="deErx.bonus.howBonusIsCalculated.copaymentExemption.description" />
          </span>
        </div>
      </div>
    </div>
  )
}
